import script from "./BoxProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./BoxProduct.vue?vue&type=script&setup=true&lang=js"

import "./BoxProduct.vue?vue&type=style&index=0&id=3b39cfb1&lang=sass&scoped=true"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b39cfb1"]])

export default __exports__